import api from '../../api/vo2api'

import Vue from 'vue'
import Vuex from 'vuex'
import errors from "./Errors";


Vue.use(Vuex);


let agreements = new class {
    constructor() {

        this.state = {
            currentType: null,
            current: null,
            currentLoading: false,
            currentLoadingError: false,
            currentLoadingErrorValue: null,
        };

        this.getters = {
            currentType:(state) => state.currentType,
            current:(state) => state.current,
            currentLoading:(state) => state.currentLoading,
            currentLoadingError: (state) => state.currentLoadingError,
            currentLoadingErrorValue: (state) => state.currentLoadingErrorValue,

        };

        this.mutations = {
            setCurrent (state, { type, model }) {
                state.currentType = type;
                state.current = model;
            },
            setCurrentLoading (state, value) {
                state.currentLoading = value
            },
            setCurrentLoadingError (state, value) {
                state.currentLoadingError = value
            },
            setCurrentLoadingErrorValue (state, value) {
                state.currentLoadingErrorValue = value
            },
        };

        this.actions = {

            select({ commit }, type) {

                commit('setCurrent', {type});
                commit('setCurrentLoadingError', false);
                commit('setCurrentLoadingErrorValue', null);

                commit('setCurrentLoading', true)
                return api.getAgreement(type).then( res => {
                    let model = res;
                    commit('setCurrent', {type, model});
                    return model
                }).catch(function (error) {
                    // handle error
                    console.log(error);
                    commit('setCurrentLoadingError', true);
                    commit('setCurrentLoadingErrorValue', errors.parseError(error));
                    return null
                }).then(value => {
                    commit('setCurrentLoading', false);
                    return value
                });
            },

            accept ({ commit }, {type, id} ) {

                commit('setCurrentLoading', true);

                return api.acceptAgreement(type, id)
                    .then( function(){
                        return true;
                    }).catch(function (error) {
                        // handle error
                        console.log(error);
                        return false
                    }).then(value => {
                        commit('setCurrentLoading', false);
                        return value
                    });
            },
        }
    }

}

const state = {
    ...agreements.state,
};
const getters = {
    ...agreements.getters,
};
const actions = {
    ...agreements.actions,
};
const mutations = {
    ...agreements.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};